import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";
import { IApiResponse } from "../../Orchestrator/Types/Index";
import { IRequestCorporateAccountRequest, IRequestCorporateAccountResponse } from "../../Orchestrator/Types/Interface/IRequestcorporate";

export async function saveRequestCorporateAccountRequest(
    request: IRequestCorporateAccountRequest
): Promise<IApiResponse<IRequestCorporateAccountResponse>> {
    const ENDPOINTS = await getEndpoints();
    const endpoint = `${ENDPOINTS.postRequestCorporateAccount}`;

    // Make the API request using the constructed endpoint and bookingRequest
    return await apiRequest<IRequestCorporateAccountResponse>(endpoint, 'POST', {
        body: JSON.stringify(request),
    });
}
